import { authAxios } from '@/common/axios';

export default {
  search: function (request) {
    return authAxios.get('/api/organization/search', { params: request });
  },
  searchShortFormat: function (request) {
    return authAxios.get('/api/organization/searchShortFormat', { params: request });
  },
  find: function (id) {
    return authAxios.get(`/api/organization/${id}`);
  },
  update: function (data) {
    return authAxios.put(`/api/organization/${data.id}`, data);
  },
  getOrgTypes: function () {
    return authAxios.get('/api/organization/orgtypes', {});
  },
  refresh: function () {
    return authAxios.get('/api/organization/refreshorganizations', {});
  },
};
